import { Popconfirm } from "antd";
import { IoRefresh } from "react-icons/io5";

import { Badge } from "./Badge";

const DISCLAIMER =
  "The calculations and results produced by the offer advisor are based on your internal payroll and market data. Please ensure accuracy of data points for optimal results.";

/**
 * Passed as the antd Drawer's `title`. The reset control lives here rather than only at the end
 * of a finished conversation, since it's mainly for recovering one that's stuck mid-run.
 */
export function AdvisorHeader({
  isComplete,
  onRestart,
}: {
  isComplete: boolean;
  onRestart: () => void;
}) {
  return (
    <div className="flex items-start justify-between gap-3 pr-6">
      <div className="min-w-0">
        <div className="truncate text-base font-semibold text-gray-800">
          TOM - AI Offer Advisor
        </div>
        <div className="mt-0.5 max-w-md whitespace-normal text-xs font-normal leading-snug text-gray-500">
          {DISCLAIMER}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2 pt-0.5">
        {isComplete && <Badge variant="success">Complete</Badge>}
        <Popconfirm
          title="Reset this conversation?"
          description="This clears everything so far and starts a brand new session — use it if the advisor gets stuck. This can't be undone."
          okText="Reset"
          cancelText="Cancel"
          placement="bottomRight"
          onConfirm={onRestart}
        >
          <button
            type="button"
            title="Reset conversation"
            className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-gray-600 transition-colors hover:bg-gray-100"
          >
            <IoRefresh className="h-3.5 w-3.5" />
            Reset
          </button>
        </Popconfirm>
      </div>
    </div>
  );
}
